import { IGroupMemberStats } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import server from "../Server";
import { GetMembersWithStatsParams } from '@grassrootly/api/gateways';

export const GetGroupMembersWithExpPoints = async ({
  date_to,
  date_from,
  gid,
}: GetMembersWithStatsParams): Promise<IGroupMemberStats[]> => {
  const infoPlayers = withErrorCheck(
    // @ts-ignore
    await server.rpc("get_top_experience_points_by_group", { date_to, date_from, gid })
  );

  if (!infoPlayers) return [];

  return infoPlayers;
};
